import { useCallback } from "react";
import * as R from "ramda";
import { useNavigate } from "react-router-dom-v5-compat";

import { useAnswerContext } from "contexts/answerContext";
import { urlFrom } from "utils/urls";

const maybeFullPathFromRelative = (relativePath) =>
  relativePath ? urlFrom(relativePath).pathname : null;

const selectPreviousPageKey = (project, currentPage) => {
  const pages = R.pathOr([], ["user_pages", "guide", "order"], project);
  const currentPageIndex = pages.indexOf(currentPage);
  return pages[currentPageIndex - 1];
};

/**
 * useOnNext
 * @param {Object} params
 * @returns {onNext}
 */
// This should be renamed, all it's doing is putting a wait/block on answer context updates
// useNextOnReady({ onReady, nextPage })
export function useOnNext({ nextPage, beforeNext = R.T }) {
  const navigate = useNavigate();
  const { onAction, context } = useAnswerContext();

  return useCallback(async () => {
    onAction(
      async (record) => {
        if (!nextPage) {
          return;
        }
        await beforeNext(record);
        navigate(maybeFullPathFromRelative(nextPage));
      },
      { validate: context?.identifier },
    );
  }, [onAction, navigate, context, beforeNext, nextPage]);
}

export function useOnBack({ page: currentPage } = {}) {
  const { record: project } = useAnswerContext();
  const previousPage = selectPreviousPageKey(project, currentPage.key);
  const navigate = useNavigate();

  return useCallback(() => {
    navigate(maybeFullPathFromRelative(previousPage) || -1);
  }, [navigate, previousPage]);
}
